var styles = {"brandHeader":"Brand-module_brandHeader__GoFu7","logo":"Brand-module_logo__EBsVJ","socialLinks":"Brand-module_socialLinks__TYxDd","whiteBg":"Brand-module_whiteBg__j-yje"};

export { styles as default };
//# sourceMappingURL=Brand.module.scss.js.map
